export interface SCurveParams {
    start: number;
    end: number;
    midpoint: number;
    steepness: number;
}

function logistic(x: number): number {
    return 1 / (1 + Math.exp(-x));
}

export function materialize(params: SCurveParams): number[] {
    const start = Number.isFinite(params.start) ? params.start : 0;
    const end = Number.isFinite(params.end) ? params.end : 0;
    let steepness = params.steepness;
    if (steepness === 0 || !Number.isFinite(steepness)) {
        steepness = 1;
    } else {
        steepness = Math.sign(steepness) * Math.max(Math.abs(steepness), 1e-6);
    }
    const midpoint = Math.min(36, Math.max(1, params.midpoint));

    const values: number[] = [];
    for (let t = 1; t <= 36; t += 1) {
        values.push(start + (end - start) * logistic((t - midpoint) / steepness));
    }
    return values;
}

export function sCurveValue(params: SCurveParams, t: number): number {
    return materialize(params)[t - 1] ?? params.start;
}
